export function goToPageReplaceQueryStringParameter(queryString, reloadPage){
	var globalQueryString = "";
	
	var urlSplit = (window.location.href).split("?");
	var queryStringSplit = [];
	if(urlSplit[1] != undefined && urlSplit[1] != ""){
		var parameterName = queryString.split("=")[0];
		var startIndex = urlSplit[1].indexOf(parameterName + "=");
		var endIndex = startIndex + urlSplit[1].substring(startIndex).split("&")[0].length;

		if(startIndex > -1){
			globalQueryString = urlSplit[1].replace(urlSplit[1].substring(startIndex,endIndex), queryString);
		}else{
			globalQueryString = urlSplit[1] + "&" + queryString;
		}
	}else{
		globalQueryString = queryString;
	}
	
	var domainSplit = window.location.href.split("/");
	var newUrl = domainSplit[0] + "//" + domainSplit[2] + "/" + domainSplit[3].split("?")[0] + "?" + globalQueryString;
	
	if(reloadPage){
		window.location.href = newUrl;
	}else{
		window.history.pushState({path:newUrl},'',newUrl);
	}
}